import {
    SET,
    RESET
} from './types';

import {
    Actions,
} from './actions';

import {
    CallerValue
} from './callervalue'


// export interface callervalue {
//     visible?:boolean;
//     ani?:string;
//     dnis?:string;
// }

/**
 *
 * @param context contains settings.json etc
 * @param initial initial state if set
 */
export const choosecaller = (
    context: any,
    initial?: CallerValue,
) => {
    let initialstate = initial || { visible: false,start:false, demo: false };
    return (
        state: CallerValue,
        action: Actions,
    ) => {
        const {
            type,
            payload,
        } = action;

        let updated = state || initialstate;
        switch (type) {
            case SET:
                updated = {
                    ...updated,
                    ...payload,
                }
                break;
            case RESET:
                updated = initialstate
                break;
        }
        return updated;
    }
};
